import React from 'react';
import { IInsuredDetails } from './index';
import { IEntityInfoView } from '@components/widgets/entity-info/EntityInfoFields';
import { EnhancedDisplayType } from '@components/widgets/dynamic-display/EnhancedDisplay';
import EntityInfoWidget from '@components/widgets/entity-info/EntityInfoWidget';
import { MAIN_THEME } from '@styles';

interface IInsuredDetailsEntityInfoProps {
  data: IInsuredDetails;
}

const InsuredDetailsEntityInfo: React.FC<IInsuredDetailsEntityInfoProps> = ({
  data,
}) => {
  if (!data) return <></>;

  const newEntityView: IEntityInfoView = {
    iconUrl: '',
    name: 'Company',
    socialMedia: {
      facebook: '',
      twitter: '',
      linkedIn: '',
    },
    title: '',
    sections: [
      {
        name: 'BasicInformation',
        title: '',
        properties: {
          Name: {
            multiline: false,
            value: data?.insuredName,
            name: 'Name',
            title: 'Name',
          },
          Code: {
            multiline: false,
            value: data.code,
            name: 'Code',
            title: 'Code',
          },
        },
      },
      {
        name: 'Section2',
        title: '',
        properties: {
          CreatedBy: {
            multiline: false,
            value: data.createdBy,
            name: 'CreatedBy',
            title: 'Created By',
          },
          CreatedOn: {
            multiline: false,
            value: data.createdOn,
            name: 'CreatedOn',
            title: 'Created On',
            type: EnhancedDisplayType.DateTime,
          },
          ModifiedBy: {
            multiline: false,
            value: data.modifiedBy,
            name: 'ModifiedBy',
            title: 'Modified By',
          },
          ModifiedOn: {
            multiline: false,
            value: data.createdOn,
            name: 'ModifiedOn',
            title: 'Modified On',
            type: EnhancedDisplayType.DateTime,
          },
        },
      },
    ],
  };

  return (
    <EntityInfoWidget
      title={data.insuredName}
      background={MAIN_THEME.color.red}
      progress={100}
      supportsClassification={true}
      supportsProgressBar={true}
      view={newEntityView}
      classification={{ classifications: {}, value: '' }}
    />
  );
};

export default InsuredDetailsEntityInfo;
